
import CallToAction from '@/components/home/CallToAction';
import SearchCallToAction from '@/components/search/SearchCallToAction';

const SearchCallToActions = () => {
  return (
    <>
      <SearchCallToAction />
      
      <div className="mt-10">
        <CallToAction 
          variant="secondary" 
          title="Discover Premium Commercial Properties in Sri Lanka" 
          description="Connect with our team of experts to find the ideal commercial property in Colombo for your business."
        />
      </div>
    </>
  );
};

export default SearchCallToActions;
